import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Slider from "react-slick"

import Office1 from "../../../static/space/studycafe/studycafe-office1.jpg"
import Office2 from "../../../static/space/studycafe/studycafe-office2.jpg"
import Office3 from "../../../static/space/studycafe/studycafe-office3.jpg"
import Office4 from "../../../static/space/studycafe/studycafe-office4.jpg"
import Office5 from "../../../static/space/studycafe/studycafe-office5.jpg"
import Office6 from "../../../static/space/studycafe/studycafe-office6.jpg"
import Office7 from "../../../static/space/studycafe/studycafe-office7.jpg"

const Container = styled.div`
  padding: 1vw 0 7vw;

  .title-slide {
    margin: 3vw 0 2vw;
  }
  .Office-slide-first img {
    width: 60vw;
    height: 30vw;
    margin-left: auto;
    margin-right: auto;
  }
  .Office-slide-first {
    height: 30vw;
  }

  .Office-slide-second {
    height: 7.5vw;
  }

  .Office-slide-second img {
    width: 14.5vw;
    margin: 0 auto;
    height: 7.5vw;
  }

  .slick-slider {
    width: 60.4vw;
    margin: 3vw auto;
  }

  .slick-next,
  .slick-prev,
  .slick-next:before,
  .slick-prev:before {
    display: none;
  }
  .hide-480 {
    display: block;
  }

  .show-480 {
    display: none;
  }

  @media screen and (max-width: 480px) {
    .hide-480 {
      display: none;
    }

    .show-480 {
      display: block;
    }

    img.slide-img-480 {
      width: 80vw;
      margin: 0 auto 2.5vw;
      display: block;
    }
  }
`

const studycafe_office = () => {
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  let slider1: any = []
  let slider2: any = []

  useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
  }, [slider1, slider2])

  return (
    <Container>
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <div className="show-480">
        <img className="slide-img-480" src={Office1} alt="오피스존1" />
        <img className="slide-img-480" src={Office2} alt="오피스존2" />
        <img className="slide-img-480" src={Office3} alt="오피스존3" />
        <img className="slide-img-480" src={Office4} alt="오피스존4" />
        <img className="slide-img-480" src={Office5} alt="오피스존5" />
        <img className="slide-img-480" src={Office6} alt="오피스존6" />
        <img className="slide-img-480" src={Office7} alt="오피스존7" />
      </div>
      <div>
        <Slider
          className="title-slide hide-480"
          asNavFor={nav2}
          ref={slider => (slider1 = slider)}
        >
          <div className="Office-slide-first">
            <img src={Office1} alt="오피스존1" />
          </div>
          <div className="Office-slide-first">
            <img src={Office2} alt="오피스존2" />
          </div>
          <div className="Office-slide-first">
            <img src={Office3} alt="오피스존3" />
          </div>
          <div className="Office-slide-first">
            <img src={Office4} alt="오피스존4" />
          </div>
          <div className="Office-slide-first">
            <img src={Office5} alt="오피스존5" />
          </div>
          <div className="Office-slide-first">
            <img src={Office6} alt="오피스존6" />
          </div>
          <div className="Office-slide-first">
            <img src={Office7} alt="오피스존7" />
          </div>
        </Slider>
        <Slider
          className="same-title-slide hide-480"
          asNavFor={nav1}
          ref={slider => (slider2 = slider)}
          slidesToShow={4}
          swipeToSlide={true}
          focusOnSelect={true}
          infinite={true}
        >
          <div className="Office-slide-second">
            <img src={Office1} alt="오피스존1" />
          </div>
          <div className="Office-slide-second">
            <img src={Office2} alt="오피스존2" />
          </div>
          <div className="Office-slide-second">
            <img src={Office3} alt="오피스존3" />
          </div>
          <div className="Office-slide-second">
            <img src={Office4} alt="오피스존4" />
          </div>
          <div className="Office-slide-second">
            <img src={Office5} alt="오피스존5" />
          </div>
          <div className="Office-slide-second">
            <img src={Office6} alt="오피스존6" />
          </div>
          <div className="Office-slide-second">
            <img src={Office7} alt="오피스존7" />
          </div>
        </Slider>
      </div>
    </Container>
  )
}

export default studycafe_office
